<div class="btn-content" matRipple matRippleColor="rgba(0, 0, 0, 0.2)" [matRippleDisabled]="load">
  <span [style.opacity]="load ? 0 : 1">
    <ng-content></ng-content>
  </span>
  @if (load) {
    <mat-spinner class="spinner" ctrSpinnerHotel colorSpinner="#171717" diameter="30"></mat-spinner>
  }
</div>
